import { useRef } from 'react'
import { useObserver } from 'mobx-react-lite'
import { useStore } from '~/app/store'

export const useCurrentLegalEntityStores = () => {
  const { globalStore, usersStore } = useStore()

  const { currentEntityStores, signature } = useObserver(() => {
    const legalEntityId = usersStore.userProfile?.legalEntity?.id
    const currentEntityStores = legalEntityId
      ? globalStore.stores.filter(
          (store) => store.legalEntityId === legalEntityId,
        )
      : []

    return {
      currentEntityStores,
      signature: currentEntityStores
        .map(({ id, legalEntityId: storeLegalEntityId, name }) =>
          [id, storeLegalEntityId, name].join(':'),
        )
        .join('|'),
    }
  })

  const storesRef = useRef({
    currentSignature: '',
    stores: currentEntityStores,
  })

  if (storesRef.current.currentSignature !== signature) {
    storesRef.current = {
      currentSignature: signature,
      stores: currentEntityStores,
    }
  }

  return storesRef.current.stores
}
